import React from 'react'

function CampaignAdminEdit() {
  return (
    <div>CampaignAdminEdit</div>
  )
}

export default CampaignAdminEdit